<template>
  <v-container>
    <v-row class="ma-1">
      <v-spacer />
      <v-btn
        rounded
        small
        color="primary"
        @click="handleGenerateNewReport"
      >
        <v-icon>mdi-plus</v-icon>
        {{ $t('reports.new.generateButton') }}
      </v-btn>
    </v-row>
    <v-data-table
      :items="items"
      :headers="headers"
      item-key="createdAt"
      sort-by="createdAt"
      sort-desc
    >
      <template v-slot:item.createdAt="{ item }">
        {{ item.createdAt | formatDate }}
      </template>
      <template v-slot:item.updatedAt="{ item }">
        {{ item.updatedAt | formatDate }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="">
          <v-btn
            icon
            @click="$router.push({ name: 'report', params: { reportId: item.id } })"
          >
            <v-icon>mdi-eye-outline</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="handleDelete(item)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { deleteReport, generateReport } from '../services'

export default {
  name: 'ReportsView',
  props: {
    contract: {
      type: Object,
      default: () => ({})
    },
    reports: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      headers: [
        { text: this.$t('common.name'), value: 'name' },
        { text: this.$t('reports.headers.createdBy'), value: 'user' },
        { text: this.$t('reports.headers.createdAt'), value: 'createdAt' },
        { text: this.$t('reports.headers.updatedAt'), value: 'updatedAt' },
        { text: '', value: 'actions' }
      ]
    }
  },
  computed: {
    items () {
      return this.reports
    }
  },
  async mounted () { },
  methods: {
    async handleDelete (item) {
      this.$eventBus.$emit('OPEN_CONFIRM_MODAL', {
        scope: {
          message: this.$t('common.deleteConfirm', { name: item.name })
        },
        handlers: {
          yes: async () => {
            await deleteReport(this.contract.id, item.id)
            this.$eventBus.$emit('CLOSE_MODAL')
            this.$emit('FETCH_DATA')
          }
        }
      })
    },
    async handleGenerateNewReport () {
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'ReportForm',
        options: { maxWidth: 650 },
        handlers: {
          generate: async (data) => {
            await generateReport(this.contract.id, data)
            this.$eventBus.$emit('CLOSE_MODAL')
            this.$emit('FETCH_DATA')
          }
        }
      })
    }
  },
  watch: { }
}
</script>
